import { v4 as uuidv4 } from 'uuid';

const CACHED_ID = uuidv4();

const getSessionID = () => CACHED_ID;

const SESSION_ID = getSessionID();

export default SESSION_ID;
